export {getScrollbarWidth} from './getScrollBarWidth';
export {isMobile, isIphone, isSafari} from './detectMobile';